/**
 * SocialRow — Iter275.4
 *
 * Standalone bottom-strip with X · LinkedIn · GitHub icons. Used in
 * BOTH the desktop site footer and the mobile/tablet nav slideout
 * so the social presence is consistent everywhere a visitor lands.
 *
 * Easy to extend when Bluesky / Mastodon go live (Track B Day 3) —
 * just push another entry into NETWORKS.
 */
import React from "react";
import { Twitter, Linkedin, Github } from "lucide-react";

const NETWORKS = [
  { label: "X",        href: "https://x.com/qortrace",                    Icon: Twitter,  testid: "social-x" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/qortrace", Icon: Linkedin, testid: "social-linkedin" },
  { label: "GitHub",   href: "https://github.com/qortrace",               Icon: Github,   testid: "social-github" },
];

export default function SocialRow({ testidPrefix = "footer", size = 14 }) {
  return (
    <div className="flex items-center gap-3"
         data-testid={`${testidPrefix}-social-row`}>
      {NETWORKS.map(({ label, href, Icon, testid }) => (
        <a key={label}
           href={href}
           target="_blank"
           rel="noopener noreferrer"
           aria-label={`QorTrace on ${label}`}
           data-testid={`${testidPrefix}-${testid}`}
           style={{
             color: "var(--qt-text-3)",
             padding: 6,
             borderRadius: 4,
             border: "1px solid var(--qt-border)",
             transition: "color 0.2s, border-color 0.2s",
             display: "inline-flex",
           }}
           onMouseEnter={(e) => {
             e.currentTarget.style.color = "var(--qt-cyan)";
             e.currentTarget.style.borderColor = "var(--qt-cyan)";
           }}
           onMouseLeave={(e) => {
             e.currentTarget.style.color = "var(--qt-text-3)";
             e.currentTarget.style.borderColor = "var(--qt-border)";
           }}>
          <Icon size={size} />
        </a>
      ))}
    </div>
  );
}
